import {
  GrossIncomeDescription,
  OtherIncomeDescription,
} from '../../../../components/FormDescriptions';
import {
  buildGroupedCurrencySchemaProperties,
  buildGroupedCurrencyUIProperties,
  DEFAULT_TITLE_OPTS,
  titleWithNameUI,
} from '../../../../definitions';
import content from '../../../../locales/en/content.json';
import { strWithYear } from '../../../../utils/helpers';

const TITLE_TEXT = strWithYear(content['dependent-info--income-title']);

const ARRAY_PATH = 'dependents';
const SCHEMA_CONFIG = [
  {
    dataField: 'grossIncome',
    subtitle: content['dependent-info--income-gross-title'],
    description: GrossIncomeDescription,
    label: strWithYear(content['dependent-info--income-gross-label']),
  },
  {
    dataField: 'netIncome',
    subtitle: content['dependent-info--income-net-title'],
    description: content['dependent-info--income-net-description'],
    label: strWithYear(content['dependent-info--income-net-label']),
  },
  {
    dataField: 'otherIncome',
    subtitle: content['dependent-info--income-other-title'],
    description: OtherIncomeDescription,
    label: strWithYear(content['dependent-info--income-other-label']),
  },
];

export default {
  uiSchema: {
    ...titleWithNameUI(TITLE_TEXT, null, {
      ...DEFAULT_TITLE_OPTS.dependents,
      placeholder: '%d',
    }),
    ...buildGroupedCurrencyUIProperties(SCHEMA_CONFIG, {
      arrayPath: ARRAY_PATH,
    }),
  },
  schema: {
    type: 'object',
    required: ['view:grossIncome', 'view:netIncome', 'view:otherIncome'],
    properties: buildGroupedCurrencySchemaProperties(SCHEMA_CONFIG),
  },
};
